import { render, staticRenderFns } from "./CreateEvents.vue?vue&type=template&id=336fdda5&"
import script from "./CreateEvents.vue?vue&type=script&lang=js&"
export * from "./CreateEvents.vue?vue&type=script&lang=js&"
import style0 from "./CreateEvents.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports